/* 地址公共接口调用方法 */

// 三方库/框架
import to from "await-to-js";
import { getServerTranslation } from "@/i18n";
import i18next from "i18next";
// 公共方法
import { initAddress, isPostCodeAddress, isAddress, setAddressCookie } from "@/utils/addressUtils";
import { isNextServer } from "@/utils/uaParser";
import { queryGlobalCountriesData } from "@/utils/countryUtils";
import JDILogin from "@/app/login/index.login";
import cookieUtils from "@/utils/cookieUtils";
// 接口
import { Address, GeolocationOptions, GeolocationLocation, Country } from "@/apis/address/address.interface"
import {
  getUserAddressList
} from "@/apis/address/address.api";
import { getLoginInfoApi } from "@/apis/login/login.api";

export const curPostCodeOrAddress = async (isDetail = false) => {
  const data = await initAddress();
  const translation = isNextServer() ? await getServerTranslation() : i18next;
  // 获取缓存postCode
  if (isPostCodeAddress(data)) {
    // 如果缓存的兜底地址 需要展示默认UK
    if (data?.isDefaultLocal) {
      return ""; //`${translation.t("common.deliverToUk")}`;
    }
    return `${translation.t("common.deliverTo")}` + " " + data?.postCode;
  }
  if (isAddress(data)) {
    // 商详展示postcode
    if (isDetail) {
      return `${translation.t("common.deliverTo")}` + " " + data?.countyName + " " + data?.postCode;
    }
    return `${translation.t("common.deliverTo")}` + " " + data?.postCode;
  }
  const [_, loginRes] = await getLoginInfoApi({ types: [6] }, { meta: { forceIgnoreLogin: true } });
  if (!(loginRes && loginRes.success && loginRes.data)) {
    return ""; //`${translation.t("common.deliverToUk")}`;
  }
  // 如果没有缓存，匹配收货地址（默认收货地址、第一天收货地址），（后端排序规则：有默认则默认在第一条）
  const [err, result] = await to(getUserAddressList());
  const list = result?.data?.addressList;
  if (list && list.length > 0) {
    if (isDetail) {
      return `${translation.t("common.deliverTo")}` + " " + list[0]?.countyName + " " + list[0]?.postCode;
    }
    return `${translation.t("common.deliverTo")}` + " " + list[0]?.postCode;
  }
  return ""; //`${translation.t("common.deliverToUk")}`;
};

// 没有缓存的时候，获取默认或者第一条作为缓存数据，目前登录、当前缓存被删除的时候需要存储下
export const setDefaultLocalAddress = async (params?: { currentCountry?: any; currentCountryCode?: string }) => {
  // 如果有缓存就直接返回
  const data = await initAddress();
  if (data) {
    return;
  }
  const { currentCountry, currentCountryCode } = params?.currentCountry && params?.currentCountryCode
    ? { currentCountry: params.currentCountry, currentCountryCode: params.currentCountryCode }
    : await queryGlobalCountriesData();
  const [loginErr, loginInfo] = await to<{isLoggedIn: boolean}>(JDILogin.getInstance().getUserInfo());
  const isLoggedIn = loginErr ? false : loginInfo.isLoggedIn;
  if (isLoggedIn) {
    // 存缓存，匹配收货地址（默认收货地址、第一天收货地址），（后端排序规则：有默认则默认在第一条）
    const [err, result] = await to(getUserAddressList());
    const list = result?.data?.addressList;
    if (list && list.length > 0 && list[0]?.countryCode === currentCountryCode) {
      setAddressCookie(list[0]);
      return;
    }
  }
  // 如果没有收货地址则缓存兜底地址 
  const { areaCode, countryCode, countryId, name, siteCode, siteId, postCode, longitude, latitude, provinceId = 0, cityId = 0, districtId = 0, townId = 0 } = currentCountry || {};
  const defaultAddress = {
    areaCode,
    countryCode,
    countryId,
    countryName: name,
    siteCode,
    siteId,
    postCode,
    longitude,
    latitude,
    provinceId,
    cityId,
    districtId,
    townId,
  } as Address;
  setAddressCookie(defaultAddress);
};

/**
 * 获取用户配送地址
 * @returns 
 */
export const curShippingAddress = async () => {
  const data = await initAddress();
  // 获取缓存postCode
  if (data?.postCode && data?.addressId) {
    return data;
  }
  // 如果没有缓存，匹配收货地址（默认收货地址、第一天收货地址），（后端排序规则：有默认则默认在第一条）
  const [err, result] = await to(getUserAddressList());
  const list = result?.data?.addressList;
  if (list && list.length > 0) {
    if (isPostCodeAddress(data)) {
      const matchedIndex = list.findIndex((item) => item.postCode === data?.postCode);
      if (matchedIndex !== -1) {
        return list[matchedIndex];
      }
    }
    return list[0];
  }
  return null;
};